/** A `datetime-local` value (local time, to the minute) for an instant. */
export function localInputValue(at: Date): string {
  const pad = (n: number): string => String(n).padStart(2, '0')
  return `${String(at.getFullYear())}-${pad(at.getMonth() + 1)}-${pad(at.getDate())}T${pad(at.getHours())}:${pad(at.getMinutes())}`
}
